import type { ChatMessage } from '~/components/Webchat/types'
import type { Delivery, ViewMessage } from '~/components/Webchat/ui/types'

export type MessageFormatters = {
  time: (iso: string) => string // -> "14:01"
  dayKey: (iso: string) => string // -> stable per-day key, e.g. "2026-06-28"
  dayLabel: (iso: string) => string // -> "ASTĂZI" / a date
}

const mapDelivery = (status?: ChatMessage['status']): Delivery => {
  switch (status) {
    case 'PENDING':
      return 'sending'
    case 'FAILED':
      return 'failed'
    default:
      return 'sent'
  }
}

// Maps the reducer's flat message list to the presentational kit model:
// assigns kind, formats timestamps, derives outbound delivery receipts,
// inserts a day divider on day change, and flags the first inbound of a group.
export function buildViewMessages(
  messages: ChatMessage[],
  fmt: MessageFormatters,
): ViewMessage[] {
  const out: ViewMessage[] = []
  let prevKind: ViewMessage['kind'] | null = null
  let prevDayKey: string | null = null

  for (const m of messages) {
    const kind: ViewMessage['kind'] =
      m.from === 'user' ? 'outbound' : m.from === 'admin' ? 'inbound' : 'system'

    const dk = m.at ? fmt.dayKey(m.at) : null
    const dayLabel = dk && dk !== prevDayKey ? fmt.dayLabel(m.at as string) : undefined

    out.push({
      id: m.key,
      kind,
      text: m.text,
      timestamp: kind !== 'system' && m.at ? fmt.time(m.at) : undefined,
      delivery: kind === 'outbound' ? mapDelivery(m.status) : undefined,
      dayLabel,
      showAvatar: kind === 'inbound' ? prevKind !== 'inbound' : undefined,
    })

    prevKind = kind
    if (dk) prevDayKey = dk
  }

  return out
}
